import axios from 'axios';

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 8000
});

export function getPhotos(params) {
  return http.get('/api/photos', { params }).then(res => res.data);
}

export function getPhotoAlbums() {
  return http.get('/api/photos/albums').then(res => res.data);
}

export function getPhotoTags() {
  return http.get('/api/photos/tags').then(res => res.data);
}

export function getPhotoTimeline() {
  return http.get('/api/photos/timeline').then(res => res.data);
}

export function getPhotoStats() {
  return http.get('/api/photos/stats').then(res => res.data);
}
